import {createSlice} from '@reduxjs/toolkit';

export const initialState = {
  afterSavePath: '/',
  orderOptionsPath: '/next',
  orderType: 'order-options',
  afterUpdateQtyFixNoSinglesIntlPath: ''
};

const pathSlice = createSlice({
  name: 'path',
  initialState,
  reducers: {
    resetAfterSavePath: state => ({...state, afterSavePath: '/'}),
    setAfterSavePath: (state, action) => ({
      ...state,
      afterSavePath: action.payload
    }),
    setOrderOptionsPath: (state, action) => ({
      ...state,
      orderOptionsPath: action.payload
    }),
    setOrderType: (state, action) => ({
      ...state,
      orderType: action.payload
    }),
    setAfterUpdateQtyFixNoSinglesIntlPath: (state, action) => ({
      ...state,
      afterUpdateQtyFixNoSinglesIntlPath: action.payload
    })
  }
});

export default pathSlice.reducer;

// Actions
export const {
  resetAfterSavePath,
  setAfterSavePath,
  setOrderOptionsPath,
  setOrderType,
  setAfterUpdateQtyFixNoSinglesIntlPath
} = pathSlice.actions;

// Selectors
export const getOrderOptionsPath = state => state.path.orderOptionsPath;
export const getOrderType = state => state.path.orderType;
export const getAfterSavePath = state => state.path.afterSavePath;
export const getAfterUpdateQtyFixNoSinglesIntlPath = state =>
  state.path.afterUpdateQtyFixNoSinglesIntlPath;
